import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const DoubleChevronLeft: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><path d="M11.25 3.75L3.75 12L11.25 20.25" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M20.25 3.75L12 12L20.25 20.25" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default DoubleChevronLeft;